import * as tslib_1 from "tslib";
import { EffectLightMapMethod } from "../methods/EffectLightMapMethod";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * EffectLightMapChunk provides a method that allows applying a light map texture to the calculated pixel colour.
 * It is different from DiffuseLightMapMethod in that the latter only modulates the diffuse shading value rather
 * than the whole pixel colour.
 */
var EffectLightMapChunk = (function (_super) {
    tslib_1.__extends(EffectLightMapChunk, _super);
    /**
     * Creates a new EffectEnvMapChunk.
     */
    function EffectLightMapChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EffectLightMapChunk.prototype._initVO = function (chunkVO) {
        this._lightMap = this._shader.getAbstraction(this._method.lightMap);
        if (this._method.useSecondaryUV)
            this._shader.secondaryUVDependencies++;
        else
            this._shader.uvDependencies++;
    };
    /**
     * @inheritDoc
     */
    EffectLightMapChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code;
        var temp = registerCache.getFreeFragmentVectorTemp();
        code = this._lightMap._getFragmentCode(temp, registerCache, sharedRegisters, this._method.useSecondaryUV ? sharedRegisters.secondaryUVVarying : sharedRegisters.uvVarying);
        switch (this._method.blendMode) {
            case EffectLightMapMethod.MULTIPLY:
                code += "mul " + targetReg + ", " + targetReg + ", " + temp + "\n";
                break;
            case EffectLightMapMethod.ADD:
                code += "add " + targetReg + ", " + targetReg + ", " + temp + "\n";
                break;
        }
        return code;
    };
    /**
     * @inheritDoc
     */
    EffectLightMapChunk.prototype._activate = function () {
        this._lightMap.activate();
    };
    EffectLightMapChunk.prototype._setRenderState = function (renderable, projection) {
        this._lightMap._setRenderState(renderable);
    };
    return EffectLightMapChunk;
}(ShaderChunkBase));
export { EffectLightMapChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectLightMapChunk.js